import { Grid } from '@material-ui/core';
import BankAccountDTO from '#root/interfaces/BankAccountDTO';
import { CreditCardIcon } from '#root/icons';
import styles from './bankAccountSelector.module.scss';

interface BankAccountSelectorProps {
  accounts: BankAccountDTO[];
  selectedAccount: string | null;
  onSelect: (accountNumber: string) => void;
  onAddNew: () => void;
  loading?: boolean;
}

const BankAccountSelector = ({
  accounts,
  selectedAccount,
  onSelect,
  onAddNew,
  loading = false,
}: BankAccountSelectorProps) => {
  // Genera un ID único para cada cuenta (banco + tipo + número + titular)
  const getAccountId = (account: BankAccountDTO) => {
    return `${account.bank_name}-${account.account_type}-${account.account_number}-${account.account_holder}`;
  };

  if (loading) {
    return (
      <div className={styles.container}>
        {[1, 2, 3].map((index) => (
          <div key={index} className={styles.skeletonCard} />
        ))}
      </div>
    );
  }

  if (accounts.length === 0) {
    return null; // El dialog manejará el empty state
  }

  return (
    <div className={styles.container}>
      <p className={styles.sectionTitle}>Selecciona una cuenta bancaria:</p>

      <div className={styles.accountGrid}>
        {/* Botón "Agregar nueva" PRIMERO para visibilidad */}
        <button type="button" className={styles.addNewButton} onClick={onAddNew}>
          <span className={styles.addNewIcon}>+</span>
          <span>Agregar nueva cuenta</span>
        </button>

        {/* Lista de cuentas guardadas */}
        {accounts.map((account) => {
          const accountId = getAccountId(account);
          // Comparar primero con accountId y luego con account_number (backward compatibility)
          const isSelected =
            selectedAccount === accountId ||
            selectedAccount === account.account_number;

          return (
            <button
              key={accountId}
              type="button"
              className={`${styles.accountButton} ${isSelected ? styles.selected : ''}`}
              onClick={() => onSelect(accountId)}>
            <div className={styles.cardContent}>
              {/* Logo del banco (esquina inferior derecha) */}
              {account.bank_colors?.path_logo && (
                <div className={styles.cardImage}>
                  <img src={account.bank_colors.path_logo} alt={account.bank_name} />
                </div>
              )}

              {/* Línea 1: Banco - Tipo de cuenta */}
              <p className={styles.bankType}>
                {account.bank_name} - {account.account_type}
              </p>

              {/* Línea 2: Titular */}
              <p className={styles.bankUser}>{account.account_holder}</p>

              {/* Línea 3: Número de cuenta */}
              <p className={styles.bankNum}>{account.account_number}</p>

              {/* Badge de moneda (esquina superior derecha) */}
              <span className={styles.currencyBadge}>{account.currency}</span>
            </div>
          </button>
          );
        })}
      </div>
    </div>
  );
};

export default BankAccountSelector;
